var _path, _path2, _path3, _path4, _path5, _path6, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeShortlisted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "completed-task",
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_55558",
    "data-name": "Path 55558",
    d: "M2.75,16H33a2.75,2.75,0,0,1,2.75,2.75V55.875A2.75,2.75,0,0,1,33,58.625H2.75A2.75,2.75,0,0,1,0,55.875V18.75A2.75,2.75,0,0,1,2.75,16Zm0,0",
    transform: "translate(0 -14.625)",
    fill: "#ffaf13"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_55559",
    "data-name": "Path 55559",
    d: "M32,76.069V48H62.25V85.125H41.056Zm0,0",
    transform: "translate(-29.25 -43.875)",
    fill: "#efefef"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_55560",
    "data-name": "Path 55560",
    d: "M41.056,374.625v9.056L32,374.625Zm0,0",
    transform: "translate(-29.25 -342.431)",
    fill: "#e76e54"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_55561",
    "data-name": "Path 55561",
    d: "M128,5.5V0h13.75V5.5A2.75,2.75,0,0,1,139,8.25h-8.25A2.75,2.75,0,0,1,128,5.5Zm0,0",
    transform: "translate(-117)",
    fill: "#e76e54"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_55562",
    "data-name": "Path 55562",
    d: "M248.75,236.375A12.375,12.375,0,1,1,236.375,224,12.375,12.375,0,0,1,248.75,236.375Zm0,0",
    transform: "translate(-204.75 -204.75)",
    fill: "#48c8ef"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_55563",
    "data-name": "Path 55563",
    d: "M302.383,331.469l-2.665-2.666a1.375,1.375,0,1,1,1.944-1.944l.891.89,6.227-5.19a1.375,1.375,0,0,1,1.761,2.113Zm0,0",
    transform: "translate(-273.593 -294.546)",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48224",
    "data-name": "Group 48224",
    transform: "translate(8.25 11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55564",
    "data-name": "Path 55564",
    d: "M161.375,128h11a1.375,1.375,0,1,1,0,2.75h-11a1.375,1.375,0,0,1,0-2.75Zm0,0",
    transform: "translate(-154.5 -128)",
    fill: "#77959e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55565",
    "data-name": "Path 55565",
    d: "M96,128h2.75v2.75H96Zm0,0",
    transform: "translate(-96 -128)",
    fill: "#77959e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55566",
    "data-name": "Path 55566",
    d: "M96,192h2.75v2.75H96Zm0,0",
    transform: "translate(-96 -186.5)",
    fill: "#77959e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55567",
    "data-name": "Path 55567",
    d: "M96,256h2.75v2.75H96Zm0,0",
    transform: "translate(-96 -245)",
    fill: "#77959e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55568",
    "data-name": "Path 55568",
    d: "M96,320h2.75v2.75H96Zm0,0",
    transform: "translate(-96 -303.5)",
    fill: "#77959e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55569",
    "data-name": "Path 55569",
    d: "M161.375,192h8.25a1.375,1.375,0,1,1,0,2.75h-8.25a1.375,1.375,0,0,1,0-2.75Zm0,0",
    transform: "translate(-154.5 -186.5)",
    fill: "#77959e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55570",
    "data-name": "Path 55570",
    d: "M161.375,256h2.75a1.375,1.375,0,1,1,0,2.75h-2.75a1.375,1.375,0,0,1,0-2.75Zm0,0",
    transform: "translate(-154.5 -245)",
    fill: "#77959e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeShortlisted);
export default __webpack_public_path__ + "static/media/home-shortlisted.4019d8baac1a082fabc36701963b8501.svg";
export { ForwardRef as ReactComponent };